module.exports = __webpack_public_path__ + "img/sld_mfm_inv_17_t1_b1_dark.6233c30d.svg";